import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, Observable, throwError } from "rxjs";

@Injectable()
export class InterceptorInterceptor implements HttpInterceptor {

  constructor(private router: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const token = sessionStorage.getItem('access_token');

    const skipUrls = [
      '/confirm-email',
      '/password-forgot',
      '/verify-otp',
      '/verify-email-otp',
      '/reset-password',
      '/confirm-email-username'
    ];

    const shouldSkip = skipUrls.some(url => request.url.includes(url));
    if (!shouldSkip && token) {
      request = request.clone({
        setHeaders: { Authorization: `Bearer ${token}` }
      });
    }

    if (!shouldSkip && !token) {
      this.router.navigateByUrl('login');
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    );
  }
}